import React, { useContext, useState, useEffect, use } from "react";
import { UserStateContext } from "../../../components/context/user-state-context.js";

import { PageHeaderMui } from "../../../components/index.js";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Tooltip,
  Button,
  Checkbox,
} from "@mui/material";
import { ShieldPersonIcon } from "../../../components/mui/index.js";
import CheckIcon from "@mui/icons-material/Check";
import LinkIcon from "@mui/icons-material/Link";

import EnhancedTable from "../../../components/mui/enhanced-table/enhanced-table.component.js";
import moment from "moment";
import { getQBCustomers } from "../../../shared/billing.api.js";

export const QuickBooksCustomerList = () => {
  const { user } = useContext(UserStateContext);

  const [renderIteration, setRenderIteration] = useState(0);

  const handleLink = (qbCustomer) => {};

  /*   useEffect(() => {
    console.log("getting qb customers");
    getQBCustomers().then((data) => {
      console.log("got qb customers", data);
    });
  }, []); */

  const headCells = [
    {
      key: "Id",
      label: "QuickBooks ID",
      width: "12%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontFamily: "monospace", fontSize: "14px" }}>
          {data.Id}
        </Typography>
      ),
    },
    {
      key: "GivenName",
      label: "Customer Name",
      width: "15%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontWeight: "bold" }}>
          {data.GivenName ? data.GivenName + " " + data.FamilyName : "--"}
        </Typography>
      ),
    },
    {
      key: "CompanyName",
      label: "Company",
      width: "15%",
      displayComponent: ({ data }) => (
        <Typography>{data.CompanyName || "--"}</Typography>
      ),
    },
    {
      key: "PrimaryEmailAddr",
      label: "Contact",
      width: "15%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontSize: "14px" }}>
          {data.PrimaryEmailAddr || "--"}
        </Typography>
      ),
    },
    {
      noSort: true,
      key: "status",
      label: "Status",
      width: "8%",
      displayComponent: ({ data }) => (
        <Typography
          sx={{
            color: data.status === "Active" ? "#2e7d32" : "#757575",
            fontWeight: 500,
          }}
        >
          Unknown
        </Typography>
      ),
    },
    {
      noSort: true,
      key: "balance",
      label: "Balance",
      width: "10%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontFamily: "monospace" }}>Unknown</Typography>
      ),
    },
    {
      noSort: true,
      key: "cinch_account",
      label: "Cinch Account",
      width: "10%",
      displayComponent: ({ data }) => (
        <Typography sx={{ fontFamily: "monospace", fontSize: "14px" }}>
          {data.account ? data.account.name : "--"}
        </Typography>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      width: "5%",
      noSort: true,
      displayComponent: ({ data }) => (
        <>
          {data.account ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Checkbox
                checked={true}
                disabled
                size="small"
                sx={{
                  color: "#2e7d32",
                  "&.Mui-disabled": {
                    color: "#2e7d32",
                  },
                }}
              />
              <Typography sx={{ color: "#2e7d32", fontSize: "14px" }}>
                Linked
              </Typography>
            </Box>
          ) : (
            <Button
              size="small"
              startIcon={<LinkIcon />}
              onClick={(e) => {
                e.stopPropagation();
                handleLink(data);
              }}
              sx={{
                textTransform: "none",
                fontSize: "14px",
              }}
            >
              Link
            </Button>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <div className="wrapper">
        <PageHeaderMui
          type="QuickBooks Customer List"
          icon={<ShieldPersonIcon />}
        />
        <Stack spacing={2}>
          <Box sx={{ px: "20px", pt: "20px" }}></Box>
          <div className="mui-wrapper">
            <EnhancedTable
              type="QuickBooks Customers"
              headCells={headCells}
              api={getQBCustomers}
              defaultSort={"CompanyName"}
              renderIteration={renderIteration}
              handleRowClick={(row) => {
                // TODO: Navigate to QuickBooks entry details when implemented
                console.log("View QuickBooks customer:", row.id);
              }}
            />
          </div>
        </Stack>
      </div>
    </>
  );
};
